export default {
    
  loader: [],

};
